import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import SetupForm from './SetupForm';
import configVars from "../../config";
import PaymentStatus from './PaymentStatus';
import { useTranslation } from "react-i18next";

const stripePromise = loadStripe("pk_live_RDZ9oLYo1JTFmuTXQBGgFD7F");

const AddNewCard = (props) => {

    const [show, setShow] = useState(false);
    const [clientSecret, setClientSecret] = useState('');
    const { stepStatus } = useParams();

    const [translation] = useTranslation("translations");

    useEffect(() => {

        (async () => {

            //setLoading(true);

            let userRequestData = new FormData();
            userRequestData.append( 'customer_id', props.customerID );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/createpaymentintent/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const userResponse = await response.json();
        
                if ( userResponse ) {
                    
                    if ( userResponse.success === true ) {
                        setClientSecret( userResponse.data.client_secret );
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            //setLoading(false);

        })()

    }, [props.customerID]);

    const options = {
        clientSecret: clientSecret,
    };

    return (
        <div className="mt-3">
            <button type="button" className="btn p-0 text-halite-blue" onClick={() => setShow(true)}>
                <i className="fa fa-plus" aria-hidden="true"></i>
                <span className="ps-2">{translation("add_new_method")}</span>
            </button>

            <Offcanvas show={show} placement="end"  onHide={() => setShow(false)}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{translation("add_new_method")}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Elements stripe={stripePromise} options={options}>
                        { stepStatus === 'saved' &&
                            <PaymentStatus />
                        }

                        { stepStatus !== 'saved' &&
                            <SetupForm />
                        }
                        
                    </Elements>
                </Offcanvas.Body>
            </Offcanvas>

        </div>
    )

}

export default AddNewCard;